import './front.scss';
import { LogoBarFront } from './LogoBarFront.js';

new LogoBarFront( document ).init();
